export default "__VITE_ASSET__B1BBzkx8__"